// extracted by mini-css-extract-plugin
module.exports = {"priceWithSavingsContainer":"az_rcd","priceAndStrikeThrough":"az_scd","addToCartDiscount":"az_tcd","dealsDrawerWrapper":"az_ucd"};